import React from "react";
import Draggable from "react-draggable";

const VideoDetailModal = ({ onClose, basicDetails }) => {
    return (
        <div
            className="modal modal-region modal-view modal-voice-view"
            id="modalId"
            style={{ display: "block" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <Draggable handle=".draggable" cancel="close">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header draggable">
                            <h5 className="modal-title" id="exampleModalLabel">
                                <div className="txt-hed">Basic Details</div>
                            </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">
                                    <img src="/img/close.svg" alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body region-otr">
                            <div className="dtl-sec system-building col-md-12">
                                <div className="region-mng">
                                    <div className="tab-active location-sec recom-sec main-dtl p-0 build-dtl dtl-dy-set-outer">
                                        <div className="row m-0 mb-0">
                                            <div className="col-md-12 p-0">
                                                <div className="row">
                                                    <div className="d-flex m-auto pt-5 pb-1 video-cover-bg">
                                                        <video height="360" controls>
                                                            <source src={basicDetails?.s3_key} type="video/mp4" />
                                                        </video>
                                                    </div>
                                                    <div className="outer-desc">
                                                        <div class="col-md-12 otr-user-cmnt">
                                                            <div class="col comment p-0">
                                                                <h3>FileName</h3>
                                                                <pre>
                                                                    <div class="contDtl">{basicDetails?.name ? basicDetails?.name : "-"}</div>
                                                                </pre>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12 otr-user-cmnt">
                                                            <div class="col comment p-0">
                                                                <h3>Narrative</h3>
                                                                <pre>
                                                                    <div class="contDtl">
                                                                        {basicDetails?.voice_text ? basicDetails?.voice_text : "-"}
                                                                    </div>
                                                                </pre>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Draggable>
        </div>
    );
};

export default VideoDetailModal;
